export { SidebarTemplate } from './SidebarTemplate'
